import(/* webpackMode: "eager", webpackExports: ["LegalDocumentPage"] */ "/opt/render/project/src/src/modules/landing/components/LegalDocumentPage.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["MarketingPageShell"] */ "/opt/render/project/src/src/modules/landing/components/MarketingPageShell.tsx");
